// extracted by mini-css-extract-plugin
module.exports = {"icon":"_962c98b","wrapper":"_936b900","subTitle":"_d2ed464","crm":"_b7bf34e"};